module.exports = __webpack_public_path__ + "media/images/no-silicon-label-db62f969757596e592f83edab3a9b5bb.png";